import React, { useState, Suspense, useEffect, useRef } from "react"
import PartsIcon from "./PartsIcon"
// import modelData from "../models.json"
import styled from "styled-components"
import { useParts } from "../provider/PartsContext"
const StyledPartsNavigationWrapper = styled.div`
  position: absolute;
  width: 95vw;
  bottom: calc(10vh + 20px);
  left: 50%;
  transform: translateX(-50%);
  display: ${(props) => (props.$visible ? "block" : "none")};
`

const StyledSliderContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
`

const StyledSlider = styled.div`
  --items-per-screen: 12;
  --slider-index: 0;
  @media (max-width: 1920px) {
    --items-per-screen: 12;
  }
  @media (max-width: 1600px) {
    --items-per-screen: 7;
  }
  @media (max-width: 1200px) {
    --items-per-screen: 6;
  }
  @media (max-width: 1000px) {
    --items-per-screen: 5;
  }
  @media (max-width: 500px) {
    --items-per-screen: 4;
  }
  display: flex;
  flex-grow: 1;
  margin: 0 var(--img-gap);
  transform: translateX(calc(var(--slider-index) * -100%));
  transition: transform 500ms ease-in-out;
`

const ScrollButton = styled.button`
  border: none;
  border-radius: 1rem;
  flex-grow: 0;
  flex-shrink: 0;
  background-color: rgba(128, 128, 128, 0.3);
  z-index: 10;
  margin: var(--img-gap) 0;
  width: var(--handle-size);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  line-height: 0;
  transition: background-color 150ms ease-in-out;
  & > .text {
    font-size: 2rem;
    transition: transform 150ms ease-in-out;
  }
  &.right-handle {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  &.handle:hover,
  .handle:focus {
    background-color: rgba(128, 128, 128, 0.25);
  }
`

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.1rem calc(var(--img-gap) * 2 + var(--handle-size));
  align-items: center;
`

const StyledProgresbar = styled.div`
  display: flex;
  gap: 0.1rem;
  & > .progress-item {
    flex: 0 0 1.5rem;
    min-width: 1.5rem;
    height: 0.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    &.active {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }
`

// category={currentCategory}
//         model={models[currentCategory]}
//         visible={visiblePartsNavi}
//         onClick={() => onPartItemClickHandler}

const PartsNavigation = ({ category, visible, onClick }) => {
  console.log("PartsNavigation")
  const { models, setModelComponents, modelComponents } = useParts()
  console.log("modelComponents", modelComponents)
  console.log("models : ", models)
  console.log("category : ", category)
  console.log("Cat Data : ", models[category])
  const scrollContainerRef = useRef(null)
  const partsIconsRefs = useRef([])
  const [isVisible, setIsVisible] = useState(
    Array(models[category]["parts"].length).fill(false)
  )

  document.addEventListener("click", (e) => {
    let handle
    if (e.target.matches(".handle")) {
      handle = e.target
    } else {
      handle = e.target.closest(".handle")
    }
    if (handle != null) onHandleClick(handle)
  })

  const onHandleClick = (handle) => {
    const progressBar = handle
      .closest(".nav-wrapper")
      .querySelector(".progressbar")
    const slider = handle.closest(".slider-container").querySelector(".slider")
    const sliderIndex = parseInt(
      getComputedStyle(slider).getPropertyValue("--slider-index")
    )
    const progressBarItemCount = progressBar.children.length

    if (handle.classList.contains("left-handle")) {
      if (sliderIndex - 1 < 0) {
        slider.style.setProperty("--slider-index", progressBarItemCount - 1)
        progressBar.children[sliderIndex].classList.remove("active")
        progressBar.children[progressBarItemCount - 1].classList.add("active")
      } else {
        slider.style.setProperty("--slider-index", sliderIndex - 1)
        progressBar.children[sliderIndex].classList.remove("active")
        progressBar.children[sliderIndex - 1].classList.add("active")
      }
    }
    if (handle.classList.contains("right-handle")) {
      if (sliderIndex + 1 >= progressBarItemCount) {
        slider.style.setProperty("--slider-index", 0)
        progressBar.children[sliderIndex].classList.remove("active")
        progressBar.children[0].classList.add("active")
      } else {
        slider.style.setProperty("--slider-index", sliderIndex + 1)
        progressBar.children[sliderIndex].classList.remove("active")
        progressBar.children[sliderIndex + 1].classList.add("active")
      }
    }
  }

  const calculateProgressBar = (progressBar) => {
    progressBar.innerHTML = ""
    const slider = progressBar.closest(".nav-wrapper").querySelector(".slider")
    const itemCount = slider.children.length
    const itemsPerScreen = parseInt(
      getComputedStyle(slider).getPropertyValue("--items-per-screen")
    )
    let sliderIndex = parseInt(
      getComputedStyle(slider).getPropertyValue("--slider-index")
    )
    const progressBarItemCount = Math.ceil(itemCount / itemsPerScreen)
    console.log("progressBarItemCount", progressBarItemCount)
    if (sliderIndex >= progressBarItemCount) {
      slider.style.setProperty("--slider-index", progressBarItemCount - 1)
      sliderIndex = progressBarItemCount - 1
    }
    for (let i = 0; i < progressBarItemCount; i++) {
      const barItem = document.createElement("div")
      barItem.classList.add("progress-item")
      if (i === sliderIndex) {
        barItem.classList.add("active")
      }
      progressBar.append(barItem)
    }
  }

  useEffect(() => {
    const throttle = (cb, delay = 1000) => {
      let shouldWait = false
      let waitingArgs
      const timeoutFunc = () => {
        if (waitingArgs == null) {
          shouldWait = false
        } else {
          cb(...waitingArgs)
          waitingArgs = null
          setTimeout(timeoutFunc, delay)
        }
      }

      return (...args) => {
        if (shouldWait) {
          waitingArgs = args
          return
        }

        cb(...args)
        shouldWait = true
        setTimeout(timeoutFunc, delay)
      }
    }
    const throttleProgressBar = throttle(() => {
      document.querySelectorAll(".progressbar").forEach(calculateProgressBar)
    }, 250)
    window.addEventListener("resize", throttleProgressBar)
    document.querySelectorAll(".progressbar").forEach(calculateProgressBar)
  })

  const updateModelComponents = (key, model) => {
    setModelComponents((prevState) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        parts: { name: model.name, path: model.path, reverse: model.reverse },
      },
    }))
  }

  useEffect(() => {
    const currentRefs = partsIconsRefs.current
    if (!scrollContainerRef.current || currentRefs.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting !== isVisible[index]) {
            setIsVisible((prevIsVisible) => {
              const newIsVisible = [...prevIsVisible]
              newIsVisible[index] = entry.isIntersecting
              return newIsVisible
            })
          }
        })
      },
      {
        root: scrollContainerRef.current,
        threshold: 1.0,
      }
    )

    currentRefs.forEach((ref, index) => {
      if (ref) {
        observer.observe(ref)
      }
    })

    return () => {
      currentRefs.forEach((ref) => {
        if (ref) {
          observer.unobserve(ref)
        }
      })
    }
  })
  return (
    <>
      {models[category] && (
        <StyledPartsNavigationWrapper
          className="nav-wrapper"
          $visible={visible}
        >
          <StyledHeader>
            <h3 className="title">{models[category]["name"]}</h3>
            <StyledProgresbar className="progressbar" />
          </StyledHeader>
          <StyledSliderContainer className="slider-container">
            <ScrollButton className="handle left-handle">
              <div className="text">&#8249;</div>
            </ScrollButton>
            <StyledSlider ref={scrollContainerRef} className="slider">
              {Object.entries(models[category]["parts"]).map(
                ([modelIndex, model]) => {
                  console.log("category : ", category)
                  return (
                    <Suspense
                      key={modelIndex}
                      fallback={<div>読み込み中...</div>}
                    >
                      <PartsIcon
                        key={modelIndex + model.path}
                        label={model.name}
                        path={model.path}
                        // visible={isVisible[index]}
                        visible={true}
                        onClick={() => updateModelComponents(category, model)}
                      />
                    </Suspense>
                  )
                }
              )}
            </StyledSlider>
            <ScrollButton className="handle right-handle">
              <div className="text">&#8250;</div>
            </ScrollButton>
          </StyledSliderContainer>
        </StyledPartsNavigationWrapper>
      )}
    </>
  )
}
export default PartsNavigation
